(function () {

    /**
     * @file
     * Сохраняет времена блокировки основного потока js
     * https://github.com/GoogleChrome/tti-polyfill
     * this snippet is a temporary workaround, until browsers implement level 2 of the Performance Observer spec
     * and include the buffered flag.
     */
    if (window.PerformanceLongTaskTiming) {
        var MAX_EVENTS_COUNT = 300,
            addEvents = function(events, entries) {
                events = events.concat(entries);
                if (events.length > MAX_EVENTS_COUNT) {
                    events = events.slice(events.length - MAX_EVENTS_COUNT);
                }
                return events;
            },
            isLongAnimationFrameAPISupported = typeof PerformanceLongAnimationFrameTiming !== 'undefined',
            poEntryTypes = isLongAnimationFrameAPISupported ?
                ['longtask', 'long-animation-frame'] :
                ['longtask'];
        function onInit() {
            var inst = Ya.Rum._tti = {
                /**
                 * Массив последних событий longtask, количество ограничено числом MAX_EVENTS_COUNT
                 */
                events: [],
                loafEvents: isLongAnimationFrameAPISupported ? [] : undefined,
                eventsAfterTTI: [],
                fired: false,

                observer: new PerformanceObserver(function(list) {
                    var longTaskEntries = list.getEntriesByType('longtask'),
                        loafEntries = list.getEntriesByType('long-animation-frame');

                    inst.events = addEvents(inst.events, longTaskEntries);
                    if (isLongAnimationFrameAPISupported) {
                        inst.loafEvents = addEvents(inst.loafEvents, loafEntries);
                    }

                    if (inst.fired) {
                        inst.eventsAfterTTI = addEvents(inst.eventsAfterTTI, longTaskEntries);
                    }
                }),
            };

            inst.observer.observe({
                entryTypes: poEntryTypes
            });

            Ya.Rum._unsubscribers && Ya.Rum._unsubscribers.push(function() {
                inst.observer.disconnect();
            });
        }
        onInit();
        Ya.Rum._onInit.push(onInit);
    }

})();
